import React from 'react';

import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

const SrApplicationProcessVideo = () => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  return (
    <iframe
      allowFullScreen
      title="YouTube video player"
      style={{ border: 0 }}
      width={isSmallScreen ? '350px' : '500px'}
      height={isSmallScreen ? '190px' : '300px'}
      src="https://www.youtube.com/embed/PHTjb4XwNtw?si=5ZI61LdxINstsWX2&amp;controls=0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" // eslint-disable-line max-len
    />
  );
};

SrApplicationProcessVideo.displayName = 'SrApplicationProcessVideo';

export default SrApplicationProcessVideo;
